import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";


import Pagination from "../../components/Pagination";
import Screen from "../../components/Screen";
import RiskAssesmentCard from "../../components/riskAssesmentCard";
// import CategoryFilter from '../category/CategoryFilter'
import EmptyData from "../../components/EmptyData";
import useAuth from "../../hooks/useAuth";
import appContext from "../../app/contextState/context";
import { RiskAssesmentContext } from "../../hooks/riskAssesmentContext";

const Collection = () => {
  const location = useLocation();
  const { collection } = useSelector((state) => state.riskAssesment);
  const state = useContext(appContext);
  const { loading } = state;
  const { limit, page, fetchRiskAssesments, setPage,setLimit } =
    useContext(RiskAssesmentContext);
  const { isCompany, isManager,user, isAdmin } = useAuth();
  const [filter, setFilter] = useState({
    company: "",
    category: "",
  });

  const template = location?.search.split("?template=")[1];
  const review = location?.search.split("?review=")[1];

  const title = template ? "Templates" : review ? "Reviews" : "Risk Assessments";
  const path = template
    ? "/checklists?template=true"
    : review
    ? "/checklists?review=true"
    : "/checklists";

  const params = {
    page,
    limit,
    company: filter.company,
    category: filter.category,
    ...(template ? { template: true } : {}),
    ...(review ? { status: "pending" } : {}),
    isCompany,
    isManager,
  };

  useEffect(() => {
    fetchRiskAssesments(params);
  }, [filter, page, limit, review, template]);
  useEffect(() => {
    setPage(1);
  }, [template]);

  const data = collection ? collection: [];
  return (
    <Screen
      loading={loading}
      filter={filter}
      setFilter={setFilter}
      faqsId={"risk_assessments"}
      flow={[
        { label: title, to: path },
        { label: "Home", to: "/risk-assesments" },
        { label: title, to: path },
      ]}
      dontShowCompany={template ? true : false}
      allowed={template && (user?.subscriptionID?.allowedRATemplates != undefined && !user?.subscriptionID?.allowedRATemplates && !isAdmin)}
    >
      <section className="section" id="checklist">
        <EmptyData data={data} onReload={() => fetchRiskAssesments(params)}>
          <div className="row icon-boxes">
            {data?.map((item, index) => {
              return (
                <RiskAssesmentCard
                  data={item}
                  key={index}
                  type="new"
                  template={template}
                  select={template}
                />
              );
            })}
          </div>
        </EmptyData>
        <Pagination
          data={collection}
          limit={limit}
          page={page}
          setPage={setPage}
          setLimit={setLimit}
        />
      </section>
    </Screen>
  );
};

export default Collection;
